import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";

import { Product } from "@transfr-inc/dashboard-components/constants";
import { Button } from "@transfr-inc/dashboard-components/forms";
import { formatTime } from "@transfr-inc/dashboard-components/utils";

import { createClassroomDetailLink } from "@lib/utils/navigation.utils";

export const TraineeCareerPathwayToolbar = ({ masteryData, classroom }) => {
  const history = useHistory();

  const goClassroomDetailsPage = () => {
    const location = createClassroomDetailLink({
      classroomId: classroom.classroomId,
      search: {
        product: Product.TRK,
        from: `Trainee`,
      },
    });
    history.push(location);
  };

  return (
    <>
      <div className="time-spent-section">
        <h3 className="headset-time-title">Time in headset</h3>
        <span className="headset-time">
          {masteryData?.totalTimespent ? (
            formatTime(masteryData?.totalTimespent)
          ) : (
            <FontAwesomeIcon icon={"fa-solid fa-hyphen"} />
          )}
        </span>
      </div>
      <Button
        size="small"
        icon={["fa-light", "screen-users"]}
        onClick={goClassroomDetailsPage}
      >
        View Classroom
      </Button>
    </>
  );
};
